import { PlusOutlined, DownloadOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { message, Space } from 'antd';

import { Button } from '../../../../components/index';
import { useChangePagination } from '../../../../hooks';
import { useLazyExportRegistersQuery } from '../../../../services/exportApi';
import { PortType } from '../../../../types';
import { PanelHeader } from '../panelHeader';
import { RegistersDrawer } from '../registersDrawer';
import { RegistersTable } from '../registersTable';
import { columns } from './columns';
import { PortForm } from './PortForm';
import { useGetBasePortsQuery } from '../../../../services/portApi';

export function Port() {
  const [searchQueryTerm, setSearchQueryTerm] = useState('');
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [selectedPort, setselectedPort] = useState<PortType | null>(null);
  const { onChangePagination, queryPage, setQueryPage } = useChangePagination();

  const {
    data: portsData,
    isFetching: isFetchingPortData,
    refetch: refetchPortData,
  } = useGetBasePortsQuery({
    complete_filter: searchQueryTerm,
    page: onChangePagination(),
    page_size: 10,
  });

  function onSavePort() {
    setselectedPort(null);
    refetchPortData();
  }
  function onCloseDrawer() {
    setIsFormVisible(false);
    setselectedPort(null);
  }

  function onSelectPort(port: PortType) {
    setselectedPort({
      ...port,
    });
    setIsFormVisible(true);
  }

  const [exportRegisters, { isLoading: isExporting }] =
    useLazyExportRegistersQuery();

  async function handleExport() {
    try {
      await exportRegisters({
        exportType: 'ports',
        params: { search: searchQueryTerm },
      }).unwrap();
      message.success(
        'Exportação em processamento. Você a receberá em seu e-mail em breve.',
        5
      );
    } catch (error) {
      message.error('Erro ao solicitar a exportação. Tente novamente.');
    }
  }

  function actionButtons() {
    return (
      <Space size={18}>
        <Button
          icon={<DownloadOutlined />}
          size="large"
          onClick={handleExport}
          loading={isExporting}
        >
          Exportar XLS
        </Button>
        <Button
          icon={<PlusOutlined />}
          type="primary"
          size="large"
          onClick={() => setIsFormVisible(true)}
        >
          Novo Porto
        </Button>
      </Space>
    );
  }
  function searchData(value: any) {
    setQueryPage(1);
    setSearchQueryTerm(value);
  }

  return (
    <>
      <RegistersDrawer visible={isFormVisible} width={640}>
        <PortForm
          name="port"
          onClose={onCloseDrawer}
          selectedPort={selectedPort}
          onSavePort={onSavePort}
          setQueryPage={setQueryPage}
        />
      </RegistersDrawer>
      <PanelHeader
        panelName="porto"
        actionButtons={actionButtons()}
        onSearch={searchData}
      />
      <RegistersTable
        rowKey="id"
        queryPage={queryPage}
        columns={columns}
        total={portsData?.count}
        dataSource={portsData?.results || []}
        onChangePagination={onChangePagination}
        isLoading={isFetchingPortData}
        showSizeChanger={false}
        onSelectItem={onSelectPort}
      />
    </>
  );
}
